import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'account.page.title': {
    id: 'account.page.title',
    defaultMessage: 'Account | {siteName}',
    description: 'Title tag',
  },
});

export default messages;
